import { Paper, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface KpiCardProps {
  title: string;
  value: ReactNode;
  subtitle?: ReactNode;
  minWidth?: number;
}

export const KpiCard = ({
  title,
  value,
  subtitle,
  minWidth = 180,
}: KpiCardProps) => (
  <Paper sx={{ p: 2, minWidth, flex: 1 }} elevation={1}>
    <Stack gap={0.5}>
      <Typography variant="caption" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="h5" fontWeight="bold">
        {value}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Stack>
  </Paper>
);
